<template>
  <div class="dialog-wrap">
    <el-dialog
      title="推广商品"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="80px"
      >
        <el-form-item label="商品类型">
          <el-select
            v-model="product_type"
            clearable
            placeholder="请选择"
          >
            <el-option
              label="课程"
              :value="1"
            >
            </el-option>
            <el-option
              label="题库"
              :value="2"
            >
            </el-option>
            <el-option
              label="专栏"
              :value="3"
            >
            </el-option>
            <el-option
              label="资料"
              :value="4"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="选择商品"
          prop="product_name"
        >
          <el-input
            :value="dataForm.product_name"
            placeholder="选择商品"
            suffix-icon="el-icon-search"
            @focus="handleGoodChoose"
            style="width:360px;"
          ></el-input>
        </el-form-item>
        <div style="display:flex;">
          <el-form-item
            label="佣金比例"
            prop="charge_rate"
          >
            <el-input
              v-model="dataForm.charge_rate"
              placeholder="请输入佣金比例"
            > <template slot="append">%</template></el-input>
          </el-form-item>
          <el-form-item
            label="佣金金额"
            prop="charge_amount"
            style="margin-left:16px;"
          >
            <el-input
              v-model="dataForm.charge_amount"
              placeholder="请输入佣金金额"
            > <template slot="append">元</template></el-input>
          </el-form-item>
        </div>
        <div style="display:flex;">
          <el-form-item
            label="奖励比例"
            prop="charge_rate_parent"
          >
            <el-input
              v-model="dataForm.charge_rate_parent"
              placeholder="请输入奖励比例"
            > <template slot="append">%</template></el-input>
          </el-form-item>
          <el-form-item
            label="奖励金额"
            prop="charge_amount_parent"
            style="margin-left:16px;"
          >
            <el-input
              v-model="dataForm.charge_amount_parent"
              placeholder="请输入奖励金额"
            ><template slot="append">元</template></el-input>
          </el-form-item>
        </div>

        <el-form-item
          label="推广等级"
          prop="promoter_level"
        >
          <el-select
            v-model="dataForm.promoter_level"
            placeholder="请选择"
            clearable
          >
            <el-option
              label="仅推广员"
              :value="1"
            >
            </el-option>
            <el-option
              label="全员推广"
              :value="0"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="tips">Tips: 固定返佣大于0时，将优先采用固定返佣计算</div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
    <ContentChoose
      :visible="goodChooseDialog"
      @close="goodChooseDialog = false"
      @submit="saveGood"
      :ref_type="1"
    ></ContentChoose>
  </div>
</template>

<script>

import ContentChoose from "@/components/dialog/ContentChoose"
import { marketingChargeEdit } from "@/api/distribution";
export default {
  components: {
    ContentChoose
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content,
      goodChooseDialog: false,
      rules: {
        /*  product_name: [{ required: true, message: '请选择商品', trigger: 'foucs' }], */
        charge_rate: [{ required: true, message: '请选择佣金比例', trigger: 'blur' }],
        charge_amount: [{ required: true, message: '请输入佣金金额', trigger: 'blur' }],
        charge_rate_parent: [{ required: true, message: '请输入奖励比例', trigger: 'blur' }],
        charge_amount_parent: [{ required: true, message: '请输入奖励金额', trigger: 'blur' }],
        promoter_level: [{ required: true, message: '请选择推广等级', trigger: 'blur' }],
      },
      product_type: 1,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.dataForm = val
      this.dataForm.charge_rate = this.dataForm.charge_rate * 100
      this.dataForm.charge_rate_parent = this.dataForm.charge_rate_parent * 100
      this.product_type = this.dataForm.product_type
    }
  },
  methods: {

    handleGoodChoose() {
      this.goodChooseDialog = true;
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataForm)
          if (!params.product_name || !params.product_id) {
            this.$message.error(`请选择商品`)
            return
          }
          params.charge_rate = Number(params.charge_rate) / 100
          params.charge_amount = Number(params.charge_amount)
          params.charge_rate_parent = Number(params.charge_rate_parent) / 100
          params.charge_amount_parent = Number(params.charge_amount_parent)
          delete params.product_name
          delete params.product_picture_url
          delete params.product_price
          delete params.product_type
          marketingChargeEdit(params).then(res => {
            this.$message.success(`创建成功`)
            this.$refs['dataForm'].resetFields()
            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    saveGood(val) {
      this.dataForm.product_id = val.id
      this.dataForm.product_name = val.name
    },
    handleClose() {
      this.dataForm = {}
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
.tips {
  margin-top: 16px;
  text-align: center;
  font-size: 12px;
  color: #999999;
}
.el-input {
  width: 130px;
}
</style>
